import { z } from 'zod';
import { useReactQuery } from '@graphql/reactQuery';
import { PersistenceStorage } from '@store/persistence';
import { SplitsFields } from './fields';

export const editedSplitsSchema = z.object({
  splitsInfo: SplitsFields,
  fundingRecipient: z.string().optional(),
});

export const getEditedSplitsPersistence = ({ releaseId }: { releaseId: string }) =>
  PersistenceStorage({
    schema: editedSplitsSchema,
    key: `@soundxyz/editedSplits-${releaseId}`,
  });

export const useEditedSplitsFromPersistence = ({ releaseId }: { releaseId?: string }) => {
  const { data: persistedSplits, isInitialLoading } = useReactQuery({
    queryKey: ['edited-splits-persistence', releaseId],
    queryFn() {
      return releaseId ? getEditedSplitsPersistence({ releaseId }).get() : null;
    },
  });

  return {
    persistedSplits,
    isInitialLoading,
  };
};

export const setPersistedSplitsForRelease = async ({
  fields,
  releaseId,
}: {
  fields: (typeof SplitsFields)['_input'];
  releaseId?: string;
}) => {
  if (!releaseId) return;
  await getEditedSplitsPersistence({ releaseId }).set({ splitsInfo: fields });
};
